import { Injectable } from '@angular/core';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { LandingPage, LandingPageState } from '../state/landing-page.state';
import { landingPageStoreKey } from '../feature/landing-page.feature';

export const getLandingPageState =
  createFeatureSelector<LandingPage>(landingPageStoreKey);

export const getActiveSignButton = createSelector(
  getLandingPageState,
  (state: LandingPage) => state.activeSignButton
);

export const getSignInDetails = createSelector(
  getLandingPageState,
  (state: LandingPage) => state.signInResponse
);

export const getSignUpDetails = createSelector(
  getLandingPageState,
  (state: LandingPage) => state.signUpResponse
);

export const getIsPasswordUpdated = createSelector(
  getLandingPageState,
  (state: LandingPage) => state.isPasswordUpdated
);

export const getIsOTPRequested = createSelector(
  getLandingPageState,
  (state: LandingPage) => state.isOTPRequested
);

@Injectable({
  providedIn: 'root',
})
export class LandingPageSelectors {
  getActiveSignButton$ = this.store.select(getActiveSignButton);
  getSignInDetails$ = this.store.select(getSignInDetails);
  getSignUpDetails$ = this.store.select(getSignUpDetails);
  getIsPasswordUpdated$ = this.store.select(getIsPasswordUpdated);
  isOTPRequested$ = this.store.select(getIsOTPRequested);

  constructor(private store: Store<LandingPageState>) {}
}
